import { LinkUtilsServiceDefinition } from '@wix/link-utils'
import { WixClientDefinition } from '@wix/viewer-service-wix-client/definition'
import { BusinessLoggerDefinition } from '@wix/viewer-service-business-logger/definition'
import { BusinessLoggerDefinition as SiteBusinessLoggerDefinition } from '@wix/site-service-business-logger/definition'
import { UrlDefinition } from '@wix/viewer-service-url/definition'
import { HeadAppenderDefinition } from '@wix/site-service-head-appender/definition'
import _ from 'lodash'

export const noopServiceImplementations = {
	[LinkUtilsServiceDefinition as string]: {
		getImpliedLinks: (html: string) => {
			return html.replace(/(https?:\/\/[^\s<]+)/g, (url) => `<a href="${url}">${url}</a>`)
		},
	},
	[WixClientDefinition as string]: {
		getWixClient: () => 'string wix client',
	},
	[BusinessLoggerDefinition as string]: {
		reportBi: () => {},
	},
	[SiteBusinessLoggerDefinition as string]: {
		reportBi: () => {},
		logger: {
			log: () => Promise.resolve(),
		},
	},
	[UrlDefinition as string]: {
		getCurrentUrl: () => '',
		getCurrentUrlWithQueryParams: () => '',
		getRelativeUrl: () => '',
		getExternalBaseUrl: () => '',
		pushUrlState: () => {},
		getFullUrlWithoutQueryParams: () => '',
	},
	// The viewer owns the document head; head content set from the platform has nowhere to go.
	// Interactions (v2) call setHead whenever process.env.browser is false, which includes the SSR platform worker.
	[HeadAppenderDefinition as string]: {
		setHead: () => {},
	},
}
